import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'brover-auth-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.sass'],
    standalone: false
})
export class LoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
